import { a as __rest } from '../../_tslib.esm.js';
import { jsx } from 'react/jsx-runtime';
import React__default from 'react';
import { Slot } from '@radix-ui/react-slot';
import styles from './Box.styles.esm.js';

const Box = React__default.forwardRef((_a, forwardedRef) => {
  var {
      className,
      asChild = false,
      as: Component = "div",
      display
    } = _a,
    props = __rest(_a, ["className", "asChild", "as", "display"]);
  const classes = styles({
    display,
    class: className
  });
  const Comp = asChild ? Slot : Component;
  return jsx(Comp, Object.assign({
    className: classes,
    ref: forwardedRef
  }, props));
});
Box.displayName = "Box";

export { Box };
